/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChildSearchFilterItemsDto } from '../../models/child-search-filter-items-dto';

export interface UserChildControllerFilter$Params {
  centerId: string;
}

export function userChildControllerFilter(http: HttpClient, rootUrl: string, params: UserChildControllerFilter$Params, context?: HttpContext): Observable<StrictHttpResponse<ChildSearchFilterItemsDto>> {
  const rb = new RequestBuilder(rootUrl, userChildControllerFilter.PATH, 'get');
  if (params) {
    rb.query('centerId', params.centerId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ChildSearchFilterItemsDto>;
    })
  );
}

userChildControllerFilter.PATH = '/api/child/user/filter';
